import Login from './login.json'
import Home from './home.json'
import Profile from './profile.json'

const messages = {
  en: {
    当前语言: 'English',
    即时通信: 'Chat',
    即时通信IM: 'Chat',
    社交娱乐: 'Entertaining & Socializing',
    腾讯云: 'Tencent Cloud',
    使用指引: 'User Guide',
    Login,
    Home,
    Profile
  }
}

export default messages
